class StaticProperties {
    static clientNameWithId = "";
    static allUserRoles = [];
    static loggedInUsersRolePermission = [];
}

export default StaticProperties;